export default "__VITE_ASSET__aebb4694__"